<template>
  <div class="clear-both"></div>
  <div class="container">
    <div class="row">
      <div class="flex justify-between">
        <div class="w-1/2 p-4">
          <h2 class="mb-5">notification_request</h2>
          <input type="text" v-model="notification_request['image']" class="form-input"/>

          <h2 class="mt-5 mb-5">Onboarding pages</h2>
          <div v-for="(link, key) in pages" :key="'form-' + key">
              <input :id="'input-' + key" type="text" v-model="link['image']" class="form-input"/>
          </div>

          <h2 class="mt-5 mb-5">Points</h2>
          <div v-for="(link, key) in points" :key="'form-' + key">
              <input :id="'input-' + key" type="text" v-model="link['image']" class="form-input"/>
          </div>

          <loading-button :loading="loading" @click="submitLink" class="mt-5 btn-indigo ml-auto">
            Save Api Domains
          </loading-button>
        </div>
        <div class="w-1/2 p-4">
          <pre>{{ jsonString }}</pre>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import {Head} from "@inertiajs/vue3";
import Layout from '@/Shared/Layout'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    Head,
    LoadingButton,
  },
  props: {
    config: Object,
    appName: String,
  },
  layout: Layout,
  data() {
    return {
      loading: false,
      notification_request: this.config.variants[0].value.notification_request,
      pages: this.config.variants[0].value.onboarding.pages,
      points: this.config.variants[0].value.package_development.offer.points,
    };
  },
  methods: {
    submitLink() {
      this.loading = true;
      axios.post('/api/config/update-batch', {
        data: {
          "variants":[
              {
                "id": this.config.variants[0].id,
                "weight": this.config.variants[0].weight,
                "value": {
                  "skip_button_text": this.config.variants[0].value.skip_button_text,
                  "welcome_page": this.config.variants[0].value.welcome_page,
                  "notification_request": this.notification_request,
                  "onboarding": {
                    "positive_button_text": this.config.variants[0].value.onboarding.positive_button_text,
                    "negative_button_text": this.config.variants[0].value.onboarding.negative_button_text,
                    "pages": this.pages
                  },
                  "package_development": {
                    "button_text": this.config.variants[0].value.package_development.button_text,
                    "loading": this.config.variants[0].value.package_development.loading,
                    "offer": {
                      "title": this.config.variants[0].value.package_development.offer.title,
                      "sub_title": this.config.variants[0].value.package_development.offer.sub_title,
                      "points": this.points,
                      "timer_duration_seconds": this.config.variants[0].value.package_development.offer.timer_duration_seconds,
                    }
                  }
                }
              }
          ]
        },
        guid: this.guid,
        appName: this.appName
      })
          .then(response => {
            this.loading = false;
            alert(`Update is queued`);
          })
          .catch(error => {
            console.error(`Error saving ${key}:`, error);
            alert(`Failed to save ${key}.`);
          });
    },
    containsImage(text) {
      return text.toLowerCase().includes('image');
    },
    serialize(obj) {
      const result = {};
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          if (typeof obj[key] !== 'function') {
            result[key] = obj[key];
          }
        }
      }
      return result;
    }
  },
  mounted() {
    console.log(this.config);
  },
  computed: {
    jsonString() {
      const dataForJson = this.serialize(this.config);
      return JSON.stringify(dataForJson, null, 2);
    }
  }
}
</script>
